
import { setDiscoveryRuleDetailProps as setDiscoveryRuleDetailPropsDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    discoveryRule?: string | number;
    discovery_rule?: string | number;
}

export const setDiscoveryRuleDetailProps = ({
    discoveryRule,
    discovery_rule,
}: Props) => setDiscoveryRuleDetailPropsDiagram({
    discoveryRule: discoveryRule ?? discovery_rule,
});


